<template>
  <b-overlay :show="loading">
    <b-form id="form-material" data-vv-scope="form-material">
      <div class="row">
        <div class="col-md-12 scroll-area">
          <ul class="list-group mt-5">
            <li
              v-for="service in materialServices"
              class="list-group-item"
              :key="service.id"
            >
              <div class="row">
                <div class="col-md-10">
                  <h6 v-b-tooltip="service.name">
                    {{ service.name }}
                  </h6>
                  <small class="text-muted">
                    {{ service.code }}
                  </small>
                </div>
                <div class="col-md-2">
                  <b-form-checkbox
                    switch
                    size="lg"
                    :value="true"
                    :unchecked-value="false"
                    v-model="service.selected"
                    data-cy="select-service"
                  ></b-form-checkbox>
                </div>
              </div>

            </li>
          </ul>
        </div>
      </div>
    </b-form>
    <vs-divider></vs-divider>
    <div class="text-right">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        v-on:click="attemptSaveMaterialServices"
        data-cy="save-material"
      >
        Guardar
      </b-button>
    </div>
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      selectedMaterial: {},
      materialServices: [],
      currentMaterialServices: [],
      loading: false
    };
  },
  props: {
    material: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('Materials', [
      'services'
    ]),
  },
  methods: {
    ...mapActions('Materials', [
      'getServices',
      'editMaterial'
    ]),
    async attemptSaveMaterialServices() {
      const services = this.materialServices
        .filter((service) => service.selected)
        .map((service) => ({
          id: service.id,
          codigo: service.code,
          nombre: service.name
        }));
      const material = {
        id: this.material.idMaterial,
        query: {
          marca: {
            opcionId: this.material.brandMaterial.opcionId,
            descripcion: this.material.brandMaterial.descripcion
          },
          categorias: [
            {
              opcionId: this.material.categoryMaterial.opcionId,
              descripcion: this.material.categoryMaterial.descripcion
            }
          ],
          precio: Number.parseInt(this.material.priceMaterial, 10),
          moneda: 'CLP',
          nombre: this.material.nameMaterial,
          SKU: this.material.skuMaterial,
          estado: this.material.state,
          servicios: services
        }
      };
      await this.editMaterial(material);
      this.$emit('edited');
    },
    verifyService(serviceId) {
      return (this.currentMaterialServices
        .some((service) => service === serviceId));
    },
    async fetchServices() {
      await this.getServices({
        grupoOpcion: 'io.solicitud.material.servicios',
        filtros: 'deshabilitado:0'
      });
      this.materialServices = this.services
        .map((service) => ({
          id: service.opcionId,
          name: service.descripcion,
          code: service.valor,
          selected: this.verifyService(service.opcionId)
        }));
    }
  },
  async mounted() {
    if (this.material.materialServices) {
      this.currentMaterialServices = this.material.materialServices
        .map((service) => service.id);
    }
    await this.fetchServices();
  }
};
</script>
